import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";
import { LabelWithDetail } from "./LabelWithDetail";

interface MemberListCardProps {
  resources: Array<{ name: string; email: string }>;
}

export const MemberListCard = ({ resources }: MemberListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.members_matching")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_members_found")}
    renderItem={member => (
      <LabelWithDetail label={member.name} detail={member.email} />
    )}
    getItemKey={member => member.email}
  />
);
